import React, { useEffect, useState } from 'react';
import { Document } from '../../queries';
import DocumentList from '../DocumentList';
import {
  InstallationGuide,
  FireCertificate,
  Warranty,
  TechnicalDrawing,
  SBDCertificate,
  AcousticCertificate,
  MaintenanceGuide,
  StorageGuide,
} from '../../constants/DocumentTypes';
import { Box } from '@material-ui/core';

interface Props {
  isEdit?: boolean;
  documents?: Partial<Document>[] | null;
}

export default function PackDocumentation({ documents }: Props) {
  const [documentList, setDocumentList] = useState<Document[]>([]);

  useEffect(() => {
    if (documents) {
      const tempList: Document[] = [];
      for (let i = 0; i < documents.length; i++) {
        const document = documents[i];
        tempList.push({
          documentType: document.documentType!,
          id: document.id!,
          originalFilename: document.originalFilename!,
          description: document.description,
          uuid: document.uuid!,
        });
      }

      setDocumentList(tempList);
    }
  }, [documents]);

  return (
    <Box p={5}>
      <DocumentList documents={documentList} />
    </Box>
  );
}
